import React, { useEffect, useState } from 'react'
import { Segmented,Form,Input,Table,Button, message, Tooltip, Popconfirm, Modal } from 'antd'
import { SERVER_ADDRESS } from '../../Config/Config'
import { EditFilled, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons'
import { TbTrashFilled } from 'react-icons/tb'
import axios from 'axios'
import './style.css'

const ViewData = () => {
    const [selectedOption,setSelectedOption] = useState('Maritial Status')
    const [loading,setLoading] = useState(false)
    const [data,setData] = useState([])
    const [editModal,setEditModal] = useState(false);
    const [currentRow, setCurrentRow] = useState(null)
    const [form] = Form.useForm();
    const [newform] = Form.useForm();
    const [searchTerm,setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [newModal,setNewModal] = useState(false)
    const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
    const userPermission = userData.privelege || []

    const handleCloseModal = ()=>{
        setEditModal(false)
        form.resetFields();
    }
    const handleNewCloseModal = ()=>{
        setNewModal(false)
        newform.resetFields();
    }

    const handleData = async(values)=>{
        const payload = {
            key:selectedOption,
            ...values
        }
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/addData`,payload)
            if(response.status===200){
                if(response.data.result === 1){
                    message.success({content:`${response.data.message}`})
                    handleNewCloseModal()
                    fetchData(selectedOption)
                }
                if(response.data.result === 0){
                    message.warning({content:`${response.data.message}`})
                }
            }
        } catch (error) {
            message.error({content:"Something Went Wrong !"})
        }
        
    }

    const handleEdit = (record)=>{
        setCurrentRow(record)
        form.setFieldsValue({
            [selectedOption.toLowerCase().replace(/\s+/g, '_')]: record[selectedOption.toLowerCase().replace(/\s+/g, '_')]
        })
        setEditModal(true)
    }

    useEffect(()=>{
        setLoading(true)
        fetchData(selectedOption)
    },[selectedOption])

    const updateData = async (values) => {
        const key = selectedOption.toLowerCase().replace(/\s+/g, '_');
        const payload = {
            key: selectedOption,
            id: currentRow.id,
            value: values[key] // correctly getting the updated value
        };
    
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/updateData`, payload);
    
            if (response.status === 200 && response.data.result === 1) {
                message.success(response.data.message);
    
                // Update the data instantly without re-fetching
                const updatedData = data.map(item =>
                    item.id === currentRow.id
                        ? { ...item, [key]: payload.value } // correctly update the row value
                        : item
                );
    
                setData(updatedData); // Reflect the changes
                setEditModal(false);
                handleSearch(searchTerm)
            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            console.log(error);
            message.error("Something went wrong!");
        }
    };

    const deleteData = async(id)=>{
        const key = selectedOption;
        const payload = {
            key,
            id
        }
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/deleteData`,payload)
            if (response.status === 200 && response.data.result === 1) {
                message.success(response.data.message);
    
                // Update the data instantly without re-fetching
                const updatedData = data.filter(datas=>datas.id !== id)
    
                setData(updatedData); // Reflect the changes
                const key = selectedOption.toLowerCase().replace(/\s+/g, '_');
                const updatedFilteredData = updatedData.filter(item => 
                    item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
                );
    
                setFilteredData(updatedFilteredData);
            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            message.error({content:"Something went wrong"})
        }
    }
    

    const fetchData = async(key)=>{
        setLoading(true);
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/viewData`,{key:key})
            if(response.status === 200){
                if(response.data.result===1){
                    setData(response.data.data)
                    setFilteredData(response.data.data);
                    setLoading(false)
                }
            }
            setLoading(false)
        } catch (error) {
            message.error({content:"Something Went Wrong !"})
            setLoading(false)
        }
    }
    
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (!value) {
            setFilteredData(data); // Reset to full data if search is empty
            return;
        }
        const key = selectedOption.toLowerCase().replace(/\s+/g, '_');
        const filtered = data.filter((item) =>
            item[key]?.toString().toLowerCase().includes(value.toLowerCase())
        );
        setFilteredData(filtered);
    };

    const options = ['Maritial Status', 'Work Sector', 'Occupation', 'Designation','Annual Income', 'Mother Tongue', 'Religion', 'Caste','Raasi','Star','Languages','Gothram','Dosham']
    
    const columns = [
        {
            title:"Id",
            dataIndex:"id",
            key:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:`${selectedOption}`,
            dataIndex:`${selectedOption.toLowerCase().replace(/\s+/g, '_')}`,
            key:`${selectedOption.toLowerCase().replace(/\s+/g, '_')}`
        },
        {
            title:'Option',
            render:(_,record)=>(
                <div className='d-flex flex-row gap-2' >
                    {userPermission.includes('edit') && (
                        <Tooltip title={`Edit ${selectedOption.toLowerCase().replace(/\s+/g, '_')}`} >
                            <Button onClick={()=>handleEdit(record)} variant='filled' color='blue' >
                                <EditFilled />
                            </Button>
                        </Tooltip>
                    ) }
                    {userPermission.includes('delete') && (
                        <Tooltip title={`Delete ${selectedOption.toLowerCase().replace(/\s+/g, '_')}`} >
                            <Popconfirm onConfirm={()=>deleteData(record.id)} title='Are You Sure want to delete ?' >
                                <Button variant='filled' color='red'>
                                    <TbTrashFilled />
                                </Button>
                            </Popconfirm>
                        </Tooltip>
                    ) }
                </div>
            )
        }
    ]

  return (
    <div style={{marginTop:'4rem'}} >
        <div>
            <Segmented options={options} selected={selectedOption} onChange={setSelectedOption} />
        </div>
        <div className='my-3 d-flex flex-row justify-content-between' >
            <Input style={{width:'14rem'}} value={searchTerm} onChange={(e)=>handleSearch(e.target.value)} placeholder={`Search By ${selectedOption}`} prefix={<SearchOutlined />} />
            {userPermission.includes('create') && (<Button className=' text-white' onClick={()=>setNewModal(true)} style={{backgroundColor:"#588157",border:"none"}} ><PlusCircleOutlined /> Add {selectedOption}</Button>) }
        </div>
        <div className='mt-3' >
            <Table columns={columns} dataSource={filteredData} rowKey={'id'} loading={loading} />
        </div>
        <Modal width={'50%'} open={editModal} onCancel={handleCloseModal} title={`Edit ${selectedOption}`} footer={false} >
            <Form onFinish={updateData} style={{padding:"2rem"}} form={form}  key={selectedOption}>
                <Form.Item label={selectedOption} labelCol={{ span: 5 }} wrapperCol={{ span: 20 }} name={selectedOption.toLowerCase().replace(/\s+/g, '_')} rules={[{ required: true, message: `Enter ${selectedOption}` }]}>
                    <Input placeholder={`Enter ${selectedOption}`} />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 5 }}>
                    <Button type='primary' htmlType='submit' variant='filled'>Update</Button>
                </Form.Item>
            </Form>
        </Modal>
        <Modal width={'50%'} title={`Add ${selectedOption}`} open={newModal} onCancel={handleNewCloseModal} footer={false} >
            <Form form={newform} onFinish={handleData} key={selectedOption}>
                <Form.Item label={selectedOption} labelCol={{ span: 5 }} wrapperCol={{ span: 20 }} name={selectedOption.toLowerCase().replace(/\s+/g, '_')} rules={[{ required: true, message: `Enter ${selectedOption}` }]}>
                    <Input placeholder={`Enter ${selectedOption}`} />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 5 }}>
                    <Button type='primary' htmlType='submit' variant='filled'>Create</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>
  )
}

export default ViewData